import React from "react";
import TreasuryMobile from "../tresorerie/TreasuryMobile";
import { useLogisticsPermissions } from "../../gestion-logistics/hooks/useLogisticsPermissions";
import { fetchLogisticsTreasuryFlows, fetchLogisticsTreasuryTotals } from "./logisticsMobileApi";

export default function LogisticsTreasuryMobile() {
  const permissions = useLogisticsPermissions();
  return (
    <TreasuryMobile
      moduleScope="logistics"
      permissions={permissions}
      title="Trésorerie logistique"
      flowLoader={fetchLogisticsTreasuryFlows}
      totalsLoader={fetchLogisticsTreasuryTotals}
    />
  );
}
